import React from "react";
import "./ConfirmModal.css";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";

const ConfirmModal = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  if (!isOpen) return null;

  const handleAccept = () => {
    navigate(-1);
    onClose();
  };

  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      dialogClassName="custom-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title></Modal.Title>
      </Modal.Header>
      <Modal.Body>
        If you leave now your progress on this video will not be saved, click “mark as done” to save your progress.
      </Modal.Body>
      <Modal.Footer style={{ justifyContent: 'center' }}>
        <p>Do you still want to leave?</p>
        <Button
          variant="secondary"
          onClick={onClose}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #949a9e",
            color: "#949a9e",
          }}
        >
          No
        </Button>
        <Button
          variant="primary"
          onClick={handleAccept}
          style={{
            backgroundColor: "#fff",
            border: "1px solid #d1b794",
            color: "#d1b794",
          }}
        >
          Yes
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
